import React, { useRef } from 'react';
import useClickOutside from '../../../../../common/hooks/useClickOutside';
import useGetSummaryData from './useGetSummaryData';

import { IWidget } from '../../../types/IWidget';

import WidgetTitle from '../widgetTitle/widgetTitle';
import Icon from '../../../../ui/icon/icon';
import OutletLoader from '../../../../ui/loaders/outletLoader/outletLoader';

import './summaryWidget.scss';

const SummaryWidget: React.FC<IWidget> = ({
                                            setup,
                                            widget,
                                            measures,
                                            scenarios,
                                            onExpand,
                                            onCollapse,
                                            expand,
                                            notes,
                                            boardId,
                                            id,
                                            staticProperties,
                                            handleWidgetChange,
                                            handleWidgetMove,
                                            widgets,
                                            changeNewIndex,
                                            changeOldIndex,
                                            customisation,
                                            selectedObject,
                                            selectedPeriod,
                                            boardSelectedCurrency,
                                            investorObjectId,
                                            homePage,
                                            handleUnpin,
                                            handlePinWidget,
                                            handleUnpinWidget,
                                            unpinId,
                                          }) => {
  const {
    summaryContentEnriched,
    values,
    loading,
    summaryNotes,
    notesShown,
    handleSummaryValueClick,
    toggleNotes,
    clickOutsideHandler,
    currencies,
    selectedCurrency,
    handleCurrencyChange,
    localCurr,
  } = useGetSummaryData(
    setup,
    widget,
    measures,
    notes,
    boardId,
    staticProperties,
    scenarios,
    selectedObject,
    selectedPeriod,
    boardSelectedCurrency,
    investorObjectId,
  );

  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, clickOutsideHandler);

  return (
    loading ? <OutletLoader /> :
      <>
        <WidgetTitle currencySelection={(widget.pinned === null || widget.setup.currencySelection) ? currencies : false}
                     selectedCurrency={selectedCurrency} localCurr={localCurr}
                     handleCurrencyChange={handleCurrencyChange} name={widget.name}
                     type={widget.type} onExpand={onExpand} onCollapse={onCollapse} expand={expand} notes={summaryNotes}
                     id={id} customisation={customisation}
                     widgets={widgets}
                     handleWidgetChange={handleWidgetChange}
                     handleWidgetMove={handleWidgetMove}
                     changeNewIndex={changeNewIndex}
                     changeOldIndex={changeOldIndex}
                     widget={widget}
                     selectedObject={selectedObject}
                     homePage={homePage}
                     investorId={investorObjectId}
                     handleUnpin={handleUnpin}
                     handlePinWidget={handlePinWidget}
                     handleUnpinWidget={handleUnpinWidget}
                     unpinId={unpinId}
        />
        <div className='widget-content'>
          <div className='summary-widget-wrapper'>
            {summaryContentEnriched.map((item, key) => (
              <div className='summary-item-wrapper' key={key}>
                <div className='summary-item-name'>
                  <span className='summary-item'>{item.name}</span>
                  {item.hasNotes && (
                    <div className='notes-wrapper'>
                      <Icon
                        name={`${notesShown.showNote === item.$$hashKey ? 'far' : 'fas'} fa-circle`}
                        className='notes-info'
                        onClick={() => toggleNotes(item.$$hashKey)}
                        id={item.$$hashKey}
                      />
                      {notesShown.showNote === item.$$hashKey && (
                        <div className='notes-content' ref={wrapperRef}>
                          {item.notes &&
                            item.notes.map((note, key) => (
                              <p key={key}>
                                {note.symbol} {note.note}
                              </p>
                            ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {values[key] && (values[key].viewCashflows ? (
                  <div className='summary-widget-value summary-widget-value-link'
                       onClick={() => handleSummaryValueClick(values[key])}>
                    {values[key].formatAmount}
                  </div>
                ) : (
                  <span className={'summary-widget-value'}>{values[key].formatAmount}</span>
                ))}
              </div>
            ))
            }
          </div>
        </div>
      </>
  );
};
export default SummaryWidget;
